function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 0H11V3.61663L9 3.61663V0ZM9 9.63934V18.0101H11V9.63934H9ZM2 0.00292969H4V8.15607H2V0.00292969ZM5 12.156H4V12.1561H2V12.156H1C0.447715 12.156 0 11.7083 0 11.156C0 10.6037 0.447715 10.156 1 10.156H5C5.55228 10.156 6 10.6037 6 11.156C6 11.7083 5.55228 12.156 5 12.156ZM2 14.1561H4V17.9923H2V14.1561ZM18 0.0273438H16V8.15587H18V0.0273438ZM18 10.1559H16V10.156H15C14.4477 10.156 14 10.6037 14 11.156C14 11.7083 14.4477 12.156 15 12.156H19C19.5523 12.156 20 11.7083 20 11.156C20 10.6037 19.5523 10.156 19 10.156H18V10.1559ZM16 17.9613V14.1559H18V17.9613H16ZM13 6.625C13 6.07272 12.5523 5.625 12 5.625H8C7.44772 5.625 7 6.07271 7 6.625C7 7.17728 7.44772 7.625 8 7.625H12C12.5523 7.625 13 7.17728 13 6.625Z"
});

var SvgIcoSettings = function SvgIcoSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "black",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-settings.2844db83.svg";
export { ForwardRef as ReactComponent };